<ion-item lines="none">
  <ion-label>{{label}}</ion-label>
  <span class="result">{{result}}</span>
</ion-item>
